import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import appRoutes from "../../routes/app.routes";
import JobLoading from "../JobSearch/JobLoading";
import NoJobsFound from "../../components/common/NotFoundPage";
import { Button, Tabs } from "../../components/common";
import PaginationComponent from "../../components/common/Pagination";
import { jobTypes } from "../../utils/appConstants";
import { useDispatch, useSelector } from "react-redux";
import { getCandidateJobApplicationsRequest } from "../../reducers/candidate/candidate.reducer";
import { scrollToTop } from "../../utils/helper";
import JobCards from "../../components/Jobs/JobCards";
import { Box, Typography } from "@material-ui/core";
// import TrackJobStepper from "./components/TrackJobStepper";

const TABS = [
  {
    id: 1,
    label: "Saved Jobs",
    value: "saved",
  },
  {
    id: 2,
    label: "Applied Jobs",
    value: "applied",
  },
];

const defaultFilter = {
  page: 1,
  pageSize: 12,
  jobType: jobTypes.FULL_TIME.id,
};

// let searchDelay: any = null;

const JobHub = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const appliedPagination = useSelector((state) =>
    _.get(state, "candidate.candidates.jobApplications.appliedPagination", {})
  );
  const savedPagination = useSelector((state) =>
    _.get(state, "candidate.candidates.jobApplications.savedPagination", {})
  );
  const appliedJobs = useSelector((state) =>
    _.get(state, "candidate.candidates.jobApplications.data.applied", [])
  );
  const savedJobs = useSelector((state) =>
    _.get(state, "candidate.candidates.jobApplications.data.saved", [])
  );
  const loading = useSelector((state) =>
    _.get(state, "candidate.candidates.jobApplications.loading", false)
  );
  const [activeTab, setActiveTab] = useState<any>(TABS[0]);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(defaultFilter);
  // eslint-disable-next-line
  const [localSavedJobs, setLocalSavedJobs] = useState<any[]>([]);
  const [localAppliedJobs, setLocalAppliedJobs] = useState<any[]>([]);
  const [isSavedChanged, setIsSavedChanged] = useState<boolean>(false);

  useEffect(() => {
    dispatch(getCandidateJobApplicationsRequest(filter));
  }, [dispatch, filter, isSavedChanged, activeTab]);

  useEffect(() => {
    if (pathname.split("/")[2] === "applied") {
      setActiveTab(TABS[1]);
    } else {
      setActiveTab(TABS[0]);
    }
    // On tab change reset the filter
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // const _handleJobTypeOption = (type: any) => {
  //   const jobType = parseInt(type);
  //   const param = { ...filter, page: 1, jobType };
  //   setPage(1);
  //   setFilter(param);
  // };

  // const _handleSearch = (q: string) => {
  //   clearTimeout(searchDelay);
  //   searchDelay = setTimeout(async () => {
  //     const param = { ...filter, page: 1, q: q };
  //     setPage(1);
  //     setFilter(param);
  //   }, 1000);
  // };
  useEffect(() => {
    setLocalSavedJobs(savedJobs);
    setLocalAppliedJobs(appliedJobs);
  }, [savedJobs, appliedJobs]);

  useEffect(() => {
    setLocalAppliedJobs(appliedJobs);
    setLocalSavedJobs(savedJobs);
  }, [isSavedChanged, savedJobs, appliedJobs]);

  const _handlePaginationChange = (value: number) => {
    setPage(value);
    const param = { ...filter, page: value };
    setFilter(param);
    scrollToTop();
  };

  const _handleJobListingRoute = () =>
    navigate(appRoutes.candidateJobSearch.path);

  const jobPostings = activeTab.id === 2 ? localAppliedJobs : localSavedJobs;
  const pagination = activeTab.id === 2 ? appliedPagination : savedPagination;
  return (
    <Box className="max-container">
      <Box className="job-hub-wrapper">
        <Box className="filter-wrapper">
          <Typography variant="h3">My Job Hub</Typography>
          <Typography variant="body1">
            Explore opportunities that match your skills and career goals.
          </Typography>
          <Box className="filter-row">
            <Box className="tab-group-wrapper">
              <Tabs
                tabs={TABS}
                active={activeTab}
                setActive={(value) => {
                  setActiveTab(value);
                  navigate(
                    appRoutes.candidateJobHub.generatePath(
                      _.get(value, "value", "saved").toLowerCase()
                    )
                  );
                }}
              />
            </Box>
            <Button
              onClick={_handleJobListingRoute}
              variant="contained"
              color="primary"
            >
              Job Listings
            </Button>
          </Box>
          {/* Temporarily hidden until further instructions */}
          {/* <span className="separator" />
          <div className={`filter-row ${activeTab.id === 2 && "justify-content-center"}`}>
            <div className="select-item">
              <SearchBar className={activeTab.id === 2 ? "apply-search-bar" : ""} handleSearch={_handleSearch} />
            </div>
            {activeTab.id === 1 && (
              <div className="select-item">
                <div>
                  <label htmlFor="job-type">Job Type</label>
                </div>
                <Radio
                  name="job-type"
                  options={JOB_TYPE_OPTIONS}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => _handleJobTypeOption(e.target.value)}
                  defaultValue={JOB_TYPE_OPTIONS.find((type) => parseInt(type.value) === filter.jobType)?.value}
                />
              </div>
            )}
          </div> */}
        </Box>
        {/* Hide to enhancement EH-392 */}
        {/* {activeTab.id === 2 && (
					<div className="stepper-wrapper">
						<h2>Track Your applied Jobs</h2>
						<TrackJobStepper applicationStatus={activeJobApplicationStatus} />
					</div>
				)} */}
        {_.isEmpty(jobPostings) && !loading ? (
          <NoJobsFound
            variant={activeTab.id === 2 ? "applied-jobs" : "saved-jobs"}
          />
        ) : (
          <Box className="list-wrapper">
            {loading ? (
              <JobLoading />
            ) : (
              jobPostings.map((job: any) => (
                <>
                  <JobCards
                    job={job}
                    noButton={true}
                    saved={activeTab.id === 1}
                    applicationStatus={_.get(job, "application_status", 0)}
                    showStatus={activeTab.id === 2}
                    setIsSavedChanged={setIsSavedChanged}
                  />
                </>
              ))
            )}
          </Box>
        )}
        {_.get(pagination, "totalPages", 0) > 1 && (
          <Box className="pagination-wrapper">
            <PaginationComponent
              count={_.get(pagination, "totalPages", 0)}
              page={page}
              variant="outlined"
              color="secondary"
              onChange={(value) => _handlePaginationChange(value)}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default JobHub;
